export const FALLBACK_MEMBERSHIP_PRICE = 59.99

export function resolveMembershipDisplayPrice(packageDetails) {
    const explicitTotal = Number(
        packageDetails?.total ??
        packageDetails?.total_including_vat
    )

    if (Number.isFinite(explicitTotal) && explicitTotal > 0) {
        return explicitTotal
    }

    const cost = Number(packageDetails?.cost ?? packageDetails?.service_cost ?? 0)
    const iva = Number(packageDetails?.iva ?? packageDetails?.vat ?? 0)
    const discount = Number(packageDetails?.discount ?? packageDetails?.discount_value ?? 0)
    const computedTotal = cost + iva - discount

    if (Number.isFinite(computedTotal) && computedTotal > 0) {
        return computedTotal
    }

    return FALLBACK_MEMBERSHIP_PRICE
}

export function resolveMembershipOriginalPrice(packageDetails) {
    const discount = Number(
        packageDetails?.discount ??
        packageDetails?.discount_value ??
        0
    )

    if (!Number.isFinite(discount) || discount <= 0) return null

    const cost = Number(packageDetails?.cost ?? packageDetails?.service_cost ?? 0)
    const vatBeforeDiscount = Number(
        packageDetails?.vat_before_discount ??
        packageDetails?.vat_beofer_discount ??
        packageDetails?.iva ??
        packageDetails?.vat ??
        0
    )
    const originalTotal = cost + vatBeforeDiscount

    if (!Number.isFinite(originalTotal) || originalTotal <= 0) return null

    const finalTotal = Number(
        packageDetails?.total ??
        packageDetails?.total_including_vat ??
        originalTotal - discount
    )

    if (Number.isFinite(finalTotal) && finalTotal >= originalTotal) return null

    return originalTotal
}
